import {apiService} from '../apiService';

export const groupService = apiService.injectEndpoints({
    endpoints: (builder) =>
        ({
            getGroupFilters: builder.query({
                query: (params) => ({
                    url: '/group/filters',
                    params
                }),
                providesTags: (_) => ['GroupFilters']
            }),
            getCustomGroupFilter: builder.query({
                query: (id) => ({
                    url: `/group/filters/custom/${id}`
                })
            }),
            getCustomGroupLikedForms: builder.query({
                query: (id) => ({
                    url: `/group/custom/${id}/linked-forms`
                })
            }),
            getGroupsByForm: builder.query({
                query: (formId) => ({
                    url: `/group/from-form/${formId}`,
                })
            }),
            createGroup: builder.mutation({
                query: (body) => ({
                    method: 'POST',
                    url: '/group',
                    data: body
                }),
                invalidatesTags: (result, error) => error ? [] : ['GroupFilters']
            }),
            updateGroup: builder.mutation({
                query: (body) => ({
                    method: 'PUT',
                    url: '/group',
                    data: body
                }),
                invalidatesTags: (result, error) => error ? [] : ['GroupFilters']
            }),
            deleteGroup: builder.mutation({
                query: (body) => ({
                    method: 'DELETE',
                    url: '/group',
                    data: body
                }),
                invalidatesTags: (result, error) => error ? [] : ['GroupFilters']
            }),
            createGroupFromFormResponses: builder.mutation({
                query: (body) => ({
                    method: 'POST',
                    url: '/group/from-form',
                    data: body
                })
            }),
            extendGroup: builder.mutation({
                query: (body) => ({
                    method: 'POST',
                    url: '/group/extend',
                    data: body
                })
            }),
            changeVisibility: builder.mutation({
                query: (body) => ({
                    method: 'POST',
                    url: '/group/change-visibility',
                    data: body
                })
            }),
            getYearGroups: builder.query({
                query: (params) => ({
                    url: '/group/year-groups',
                    params
                })
            }),
            getBoarderGroups: builder.query({
                query: () => ({
                    url: '/group/boarder-groups',
                    method: 'GET',
                }),
                providesTags: ['BoarderGroups'],
            }),
            getIntakes: builder.query({
                query: (params) => ({
                    url: '/group/intakes',
                    params
                })
            }),
            getGroupUsers: builder.query({
                query: (groupId) => ({
                    url: `/group/${groupId}/users`
                })
            }),
            manageGroupUsers: builder.mutation({
                query: (body) => ({
                    method: 'PUT',
                    url: '/group/manage-users',
                    data: body
                }),
                invalidatesTags: (result, error, {groupId}) =>
                    error ? [] : [{type: 'GroupUsers', id: groupId}]
            }),
            getGroupAccess: builder.query({
                query: (groupId) => ({
                    url: `/group/${groupId}/access`
                })
            }),
            manageGroupAccess: builder.mutation({
                query: (body) => ({
                    method: 'PUT',
                    url: '/group/manage-access',
                    data: body
                }),
                invalidatesTags: (result, error, {groupId}) =>
                    error ? [] : [{type: 'GroupAccess', id: groupId}]
            }),
        }),
});

export const {
    useGetGroupFiltersQuery,
    useGetCustomGroupFilterQuery,
    useCreateGroupMutation,
    useUpdateGroupMutation,
    useDeleteGroupMutation,
    useCreateGroupFromFormResponsesMutation,
    useExtendGroupMutation,
    useChangeVisibilityMutation,
    useGetYearGroupsQuery,
    useGetBoarderGroupsQuery,
    useGetIntakesQuery,
    useGetGroupsByFormQuery,
    useGetGroupAccessQuery,
    useManageGroupAccessMutation,
} = groupService;
